// extracted by mini-css-extract-plugin
export default {"header":"Header_header__smcd-","title":"Header_title__m3a40","name":"Header_name__agS0L","link":"Header_link__rxF4I"};